<template>
  <div class="app">
    <Header/>
    <kendo-notification ref="popupNotification"></kendo-notification>
    <div class="app-body">
      <sidebar :navItems="nav"/>
      <main class="main">
        <Breadcrumb :list="list" :action="button"/>
        <div class="container-fluid" style="margin-bottom: 100px;">
          <nprogress-container style="height: 3px !important; z-index: 9999;"></nprogress-container>
          <router-view></router-view>
        </div>
      </main>
      <Aside/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import nav from '../_nav'
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Aside from '../components/Aside'
import Footer from '../components/Footer'
import Breadcrumb from '../components/Breadcrumb'

export default {
  components: {
    Header,
    Sidebar,
    Aside,
    Footer,
    Breadcrumb,
    NprogressContainer
  },
  metaInfo () {
    return {
      title: 'Infia Commerce - An Integrated Sales Management',
      link: [
        { rel: 'stylesheet', href: '/static/css/custom.css' },
        { rel: 'stylesheet', href: 'https://use.fontawesome.com/releases/v5.0.9/css/all.css', integrity: 'sha384-5SOiIsAziJl6AWe0HWRKTXlfcSHKmYV4RBF18PPJ173Kzn7jzMyFuTtk8JA7QQG1', crossorigin: 'anonymous' },
        { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' },
        { rel: 'stylesheet', href: 'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.1.0/css/bootstrap-grid.min.css' }
      ]
    }
  },
  data () {
    return {
      nav: nav.items,
      button: {
        name: 'Add Sales',
        icon: 'fa fa-cart-plus',
        url: '/sales/add'
      },
      notification: null
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  mounted () {
    this.notification = this.$refs.popupNotification.kendoWidget()
  },
  methods: {
    showNotification (message, type) {
      this.notification.show(message, type)
    },
    onNotifShow (event) {
      console.log('popup show', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue